module.exports = __webpack_public_path__ + "static/media/fvs_valve1_10.c51505bc.jpg";